<template>
  <v-container>
    <v-row :class="videoDescription ? 'mb-6' : 'mb-2'">
      <div class="display-3 text-wrap">
        {{ videoName || 'Untitled Video' }}
      </div>
    </v-row>
    <v-row v-if="videoDescription" align="center">
      <v-card width="100%" elevation="1">
        <v-card-title class="headline">
          Description
          <v-spacer />
          <v-icon large color="primary">mdi-card-bulleted-outline</v-icon>
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="display-2 multiline">{{ videoDescription }}</div>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'VideoDetails',
  computed: {
    ...mapState('video', {
      videoName: state => state.current.metadata.name,
      videoDescription: state => state.current.metadata.description,
    }),
  },
};
</script>

<style scoped>
.multiline {
  white-space: pre-line;
}
</style>
